export const styles = {
  container: {
    display: "flex",
    justifyContent: { xs: "center", md: "space-between" },
    flexWrap: "wrap",
    gap: 2,
  },
  cardWrapper: { mt: 2, textDecoration:"none", color:"inherit" },
  item: (theme) => ({
    textAlign: "center",
    width: "250px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
  }),
};
